var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCleanAirCompliant24 = function SvgCleanAirCompliant24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.473 13.616a1.043 1.043 0 0 0-.411-.578 1.24 1.24 0 0 0-.706-.2 1.35 1.35 0 0 0-.55.108 1.206 1.206 0 0 0-.42.312c-.12.142-.21.305-.265.481a2.142 2.142 0 0 0 0 1.265c.056.176.148.339.27.479.116.13.26.232.42.3a1.442 1.442 0 0 0 1.289-.103 1.09 1.09 0 0 0 .45-.543l.806.348a1.797 1.797 0 0 1-.782.912c-.372.22-.799.332-1.231.324a2.386 2.386 0 0 1-.899-.167 2.001 2.001 0 0 1-.699-.476 2.107 2.107 0 0 1-.449-.74 2.979 2.979 0 0 1 0-1.922 2.19 2.19 0 0 1 .45-.748c.195-.211.434-.377.7-.486.286-.114.591-.173.9-.17.441-.014.876.113 1.241.361.33.232.57.572.675.962l-.79.28Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.757 8a4.06 4.06 0 0 1 2.639.966 3.758 3.758 0 0 1 1.3 2.407l.162.094a3.984 3.984 0 0 1 2.385 1.487c.576.762.838 1.702.735 2.638a3.758 3.758 0 0 1-1.293 2.432 4.06 4.06 0 0 1-2.656.976H6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.924 19a3.962 3.962 0 0 1-2.252-.7 3.876 3.876 0 0 1-1.436-1.848 3.818 3.818 0 0 1-.101-2.327 3.864 3.864 0 0 1 1.27-1.962h.091v-.962c0-1.327.433-2.62 1.234-3.688a6.29 6.29 0 0 1 3.216-2.241 6.376 6.376 0 0 1 3.938.083A6.28 6.28 0 0 1 15 7.73L5.924 19Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCleanAirCompliant24;